import pretty from "pretty";
/**
 * Prettify an HTML script to make it more human-readable.
 * This is the Node version; for Web Browser environments, use the one from "utils-library/dist/web".
 */
export const prettifyHTML = (html) => pretty(html);
